"use client"
import React from 'react';
import { Grid, Container } from '@mui/material';
import Block1 from './block1';
import Block2 from './block2';
import Block3 from './block3';

const CardOnHome = () => {

    //const blockContent = "As tires age, they are prone to failure. Some auto & tire manufacturers recommend replacing tires at (6) years of age, even if the tire has never been on the road. Tire aging occurs due to degradation on the inside of the tire and is invisible to the human eye & is often referred to as the invisible hazard.";

    return (
        <Container
            direction="row"
            disableGutters
            maxWidth={false}
            sx={{
                backgroundColor: "#F4F5F5",
                padding: {
                    xs: "5px",
                    sm: "50px",
                    lg: "50px"
                },
                marginTop: "20px"
            }}
        >
            <Container
                direction="row"
                disableGutters
                maxWidth={"xl"}
                sx={{
                    backgroundColor: "#F4F5F5",
                    padding: {
                        xs: "0px",
                        sm: "50px",
                        lg: "50px"
                    },
                }}
            >
                <Grid container item direction={"row"} justifyContent="space-evenly" >

                    <Grid item lg={4} xs={12}>
                        <Block3
                            value={{
                                title: "Tire Endurance Forensic Testing",
                                subHeader: "This forensic study simulates real-world conditions to evaluate a tire's longevity and durability, and other performance levels.",
                                content: "",
                                image: "/block2.png"
                            }}
                        />
                    </Grid>
                    <Grid item lg={4} xs={12}>
                        <Block3
                            value={{
                                title: "Tire Shearography Forensic Inspection",
                                subHeader: "This forensic study uses lasers and cameras to detect internal defects and anomalies inside the tire.",
                                content: "",
                                image: "/block3.png"
                            }}
                        />
                    </Grid>
                    {/* <Grid item md={4}>
                        <Block3
                            value={{
                                title: "Customers are safer on the roads",
                                subHeader: "Dealership's customers are Safer on the Roads with Tirefax Safety Alerts (TSA), Recall alerts and expiration alerts.",
                                content: "Dealership's customers are Safer on the Roads with Tirefax Safety Alerts (TSA), Recall alerts and expiration alerts. Dealership's customers are Safer on the Roads with Tirefax Safety Alerts (TSA).",
                                image: "/blocK1.jpeg"
                            }}
                        />
                    </Grid> */}
                </Grid>
            </Container>
        </Container>
    )
}

export default CardOnHome;
